import BillStatistic from './index';

export default { path: '/home/publicAccountBillStatistic', component: BillStatistic };
